export class AdministrativeProcedureDetailsViewModel {    
  id: number;  
  name: string;
  description: string;
  //admProcedureCategoryId: number; //JSON ignore u Backend-u
  administrativeProcedureCategory: AdministrativeProcedureCategory; 
  dateCreated: string;
  criteria: string;
  note: string;  
  organizationalUnit: OrganizationalUnit;
  originatingRegistryJurisdiction: string;
  validityPeriod: string;
  legalBasis: string;  
  administrativeProcedureType: AdministrativeProcedureType;  
  administrativeProcedureStatus: AdministrativeProcedureStatus;  
  sophisticationLevel: SophisticationLevel;  
  procedureRefersTo: ProcedureRefersTo;  
  outputType: OutputType;  
  legalRemedy: LegalRemedy;
  resolutionDeadline: string;
  stepByStepInstructions: StepByStepInstruction[];
  contactPersons: ContactPerson[];
  administrativeProcedureTaxes: AdministrativeProcedureTax[];
  usefulLinks: UsefulLink[];
  administrativeProcedureDocuments: AdministrativeProcedureDocument[];    
  requiredDocumentTypes: RequiredDocumentType[];
  availableInElectronicForm: boolean;

    constructor() {
        this.organizationalUnit = new OrganizationalUnit();
        this.contactPersons = [];
        this.administrativeProcedureTaxes = [];
        this.usefulLinks = [];
        this.administrativeProcedureDocuments = [];
        this.administrativeProcedureType = new AdministrativeProcedureType();
        this.administrativeProcedureStatus = new AdministrativeProcedureStatus();
        this.sophisticationLevel = new SophisticationLevel();
        this.stepByStepInstructions = [];
        this.procedureRefersTo = new ProcedureRefersTo();
        this.outputType = new OutputType();
        this.legalRemedy = new LegalRemedy();
        this.administrativeProcedureCategory = new AdministrativeProcedureCategory();
        this.requiredDocumentTypes = [];
      }
  }
  
  class OrganizationalUnit {
    id: number
    name: string
    description: string
    code: string
  }
  
  export class ContactPerson {
    id: number
    administrativeProcedureId: number
    fullName: string
    title: string
    phoneNumber: string
    email: string
    active: boolean
    dateCreated: string
  }
  
  class AdministrativeProcedureTax {
    id: number
    administrativeProcedureId: number
    name: string
    amount: string
    accountNumber: string
    referenceNumber: string
    active: boolean
    dateCreated: string
  }

  class UsefulLink {
    id: number
    url: string
    description: string
  }

  class AdministrativeProcedureDocument {
    id: number
    name: string
    documentPath: string
    active: boolean
    dateCreated: string
  } 

  class AdministrativeProcedureType {
    id: number
    active: boolean
    dateCreated: string
    name: string
    description: any
  }

  class AdministrativeProcedureStatus {
    id: number
    active: boolean
    dateCreated: string
    name: string
    description: any
  }
  
  class SophisticationLevel {
    id: number
    name: string
    description: string
    active: boolean
    dateCreated: string
  }
  
  class StepByStepInstruction {
    id: number
    ordinalNumber: number
    text: string
    active: boolean
    dateCreated: string
  }
  
  class ProcedureRefersTo {
    id: number
    name: string
    description: any
    active: boolean
    dateCreated: string
  }
  
  class OutputType {
    id: number
    name: string
    description: any
    active: boolean
    dateCreated: string
  }
  
  class LegalRemedy {
    id: number
    name: string
    description: string
    active: boolean
    dateCreated: string
  }
  
  class AdministrativeProcedureCategory {
    id: number
    parentAdmProcedureCategoryId: number
    name: string
    parentCategoryName: string
    description: string
    active: boolean
    dateCreated: string
    iconPath: any
    published: boolean
  }
  
  class RequiredDocumentType {
    id: number
    name: string
    description: string
    issuingInstitution: string
    comment: string
    administrativeProcedureId: number
    documentDeliveryFormId: number
    active: boolean
    dateCreated: string
    documentDeliveryForm: DocumentDeliveryForm
  }
  
  class DocumentDeliveryForm {
    id: number
    name: string
    active: boolean
    dateCreated: string
  }